import { render, staticRenderFns } from "./ColumnTable.vue?vue&type=template&id=09e9a2fe&scoped=true"
import script from "./ColumnTable.vue?vue&type=script&lang=js"
export * from "./ColumnTable.vue?vue&type=script&lang=js"
import style0 from "./ColumnTable.vue?vue&type=style&index=0&id=09e9a2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9a2fe",
  null
  
)

export default component.exports